<template>

  <div>
    <div class="Banner">
      <img src="../../assets/yaq_banner.png" alt="">
    </div>
    <div class="container">
      <div class="title">
        <h1>
          云备份、云服务、云安全
        </h1>
        <aside>
          CLOUD BACKUP, CLOUD SERVICES, CLOUD SECURITY
        </aside>
      </div>
      <div class="row">
        <div class="col-sm-6 col-xs-12">
          <h4>
            随着虚拟化技术及云计算科技在各行各业的普及迅速提高，企业选择不再单一的将业务数据存储在企业内部，而是将核心数据存放在互联网数据中心或服务供应商的设施内。为了保护企业数据安全，保障企业业务持续运行，悦享互联提供多方位的托管备份，复制及恢复解决方案，配合同城及异地备份的作业模式，以及多元化的物理和虚拟复制形式，让企业可安心专注核心业务。</h4>
          <p>
            综合迅速的同城及异地备份服务
          </p>
          <p>
            数据备份服务：
            <span>
              P2C备份 / C2C备份 / V2C备份
            </span>
          </p>
          <p>
            数据复制及数据恢复：
            <span>
              P2C复制 / C2C复制 / V2C复制
            </span>
          </p>
          <p>
            产品特点
          </p>
          <aside>
            7x24主动监控复制服务情况，遇故障时发出警报并修复事故 <br>
            弹性备份和复制策略，客户可按小时至按月来设定 <br>
            数据压缩和重复删除技术，优化储存空间 <br>
            创新方向增量技术，加快恢复时间 <br>
            综合的同城及异地备份服务 <br>
            备份和复制运作由悦享互联经验丰富的技术团队鼎力支持 <br>
            通过专用网络及SSL加密技术，安全传送数据 <br>
            全球服务器负载均衡技术，保护业务运作持续 <br>
            可自定义备份或复制的时间表及保留原则 <br>
          </aside>
        </div>
        <div class="col-sm-6 col-xs-12">
          <img src="../../assets/security_pic01.jpg" style="margin-bottom: 30px" alt="">
          <img src="../../assets/security_pic02.jpg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <Footer/>
  </div>

</template>

<script>

  import Footer from '../../components/Footer'

  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    props: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
  }

  .Banner {
    margin-bottom: 4rem;
  }

  h1 {
    font-size: 4.6rem;
    color: #fe9901;
  }

  aside {
    font-size: 1.8rem;
    color: #666;
    text-transform: uppercase;
    line-height:36px;
  }

  .title {
    padding-left: 30px;
    border-left: 1px solid #ccc;
    margin-bottom: 4rem;
  }

  h4 {
    color: #333;
    font-size: 1.8rem;
    text-indent: 30px;
    line-height: 35px;
    margin-bottom: 25px;
    font-weight: normal;
  }

  p {
    color: #333;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 0px;
    font-weight: bold;
  }



  .text {

    color: #666;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 0px;
    font-weight: normal;
    padding-left: 30px;
  }


  p span{
    text-align: left;
    color: #333;
  }
  


</style>
